(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  class CookieConsentBanner extends HTMLElement {
    static STORAGE_KEY = 'mevya_cookie_consent';

    connectedCallback() {
      this.panel = this.querySelector('[data-settings-panel]');
      this.acceptBtn = this.querySelector('[data-consent-accept]');
      this.rejectBtn = this.querySelector('[data-consent-reject]');
      this.settingsBtn = this.querySelector('[data-consent-settings]');
      this.saveBtn = this.querySelector('[data-consent-save]');
      this.categoryInputs = this.querySelectorAll('[data-consent-category]');

      const existing = this.readConsent();
      if (existing) {
        this.dispatchConsent(existing);
        this.syncShopifyConsent(existing);
        return;
      }

      this.hidden = false;

      this.acceptBtn.addEventListener('click', () => this.save({ statistics: true, marketing: true }));
      this.rejectBtn.addEventListener('click', () => this.save({ statistics: false, marketing: false }));
      this.settingsBtn.addEventListener('click', () => this.togglePanel());
      this.saveBtn.addEventListener('click', () => {
        const consent = {};
        this.categoryInputs.forEach((input) => {
          consent[input.dataset.consentCategory] = input.checked;
        });
        this.save(consent);
      });
    }

    togglePanel() {
      const isHidden = this.panel.hidden;
      this.panel.hidden = !isHidden;
      this.saveBtn.hidden = isHidden ? false : true;
      this.acceptBtn.hidden = !isHidden ? false : true;
      this.rejectBtn.hidden = !isHidden ? false : true;
    }

    readConsent() {
      try {
        const raw = localStorage.getItem(CookieConsentBanner.STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    save(consent) {
      const payload = { necessary: true, ...consent, timestamp: Date.now() };
      try {
        localStorage.setItem(CookieConsentBanner.STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {
        /* localStorage nicht verfuegbar - Consent gilt nur fuer diese Sitzung */
      }
      this.hidden = true;
      this.dispatchConsent(payload);
      this.syncShopifyConsent(payload);
    }

    dispatchConsent(consent) {
      window.dispatchEvent(new CustomEvent('mevya:consent-updated', { detail: consent }));
    }

    syncShopifyConsent(consent, attempt) {
      attempt = attempt || 0;
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!consent.statistics,
          marketing: !!consent.marketing,
          preferences: true,
          sale_of_data: !!consent.marketing
        }, function () {});
        return;
      }
      if (attempt < 20) {
        setTimeout(() => this.syncShopifyConsent(consent, attempt + 1), 250);
      }
    }
  }

  customElements.define('cookie-consent-banner', CookieConsentBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  class StatCounters extends HTMLElement {
    connectedCallback() {
      this.counters = Array.from(this.querySelectorAll('[data-counter]'));
      if (this.counters.length === 0) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.animate(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.4 });

      this.counters.forEach((el) => observer.observe(el));
    }

    animate(el) {
      const target = parseFloat(el.dataset.target) || 0;
      const duration = 1400;
      const start = performance.now();
      const isDecimal = String(target).includes('.');

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = target * eased;
        el.textContent = isDecimal ? value.toFixed(1) : Math.round(value);
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  customElements.define('stat-counters', StatCounters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.testimonials__track');
      this.slides = Array.from(this.querySelectorAll('.testimonials__slide'));
      this.dotsWrap = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      if (this.slides.length === 0) return;

      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Zu Folie ' + (i + 1) + ' springen');
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(dot);
      });
      this.dots = Array.from(this.dotsWrap.children);

      this.prevBtn.addEventListener('click', () => this.step(-1));
      this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });

      this.syncDots();
    }

    step(direction) {
      const slideWidth = this.slides[0].getBoundingClientRect().width + 24;
      this.track.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
    }

    goTo(index) {
      const slideWidth = this.slides[0].getBoundingClientRect().width + 24;
      this.track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    }

    syncDots() {
      const slideWidth = this.slides[0].getBoundingClientRect().width + 24;
      const activeIndex = Math.round(this.track.scrollLeft / slideWidth);
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
      });
    }
  }

  customElements.define('testimonial-carousel', TestimonialCarousel);

  } catch(e) { console.error(e); }
})();
})();
